<!--
 * @Description: 抽检
 * @Author: wangwangwang
 * @Date: 2020-09-21 14:09:06
 * @LastEditors: wangwangwang
 * @LastEditTime: 2020-09-24 14:25:33
-->
<template>
  <CommonCheckout :dataTypeId='4'/>
</template>

<script>
import CommonCheckout from './commoncheckout'
export default {
  components: {
    CommonCheckout
  },
};
</script>
